var _title;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitlab = function SvgGitlab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "logo-gitlab")), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9415 18.8562L30.149 13.3468L26.6018 2.41914C26.561 2.29723 26.4829 2.19123 26.3785 2.11613C26.2742 2.04103 26.1488 2.00063 26.0203 2.00063C25.8917 2.00063 25.7664 2.04103 25.662 2.11613C25.5577 2.19123 25.4796 2.29723 25.4387 2.41914L21.8916 13.3402H10.106L6.55886 2.41914C6.51828 2.29711 6.44031 2.19095 6.33602 2.11572C6.23172 2.04049 6.10638 2 5.97778 2C5.84918 2 5.72384 2.04049 5.61954 2.11572C5.51524 2.19095 5.43728 2.29711 5.3967 2.41914L1.85524 13.3402L0.0627127 18.8562C-0.0169228 19.1011 -0.017083 19.3649 0.0622557 19.6099C0.141594 19.8549 0.296368 20.0685 0.504446 20.2203L16.0002 31.4797L31.4931 20.2203C31.7022 20.0692 31.8581 19.856 31.9386 19.611C32.0191 19.366 32.0202 19.1018 31.9415 18.8562Z",
    fill: "#FC6D26",
    style: {
      fill: "#FC6D26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 31.4712L21.8925 13.3392H10.1107L16.0002 31.4712Z",
    fill: "#E24329",
    style: {
      fill: "#E24329"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 31.4712L10.106 13.3392H1.85901L16.0002 31.4712Z",
    fill: "#FC6D26",
    style: {
      fill: "#FC6D26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85237 13.345L0.0598437 18.8543C-0.0197918 19.0992 -0.0199513 19.363 0.0593873 19.608C0.138726 19.853 0.2935 20.0667 0.501578 20.2184L16.0002 31.4798L1.85237 13.345Z",
    fill: "#FCA326",
    style: {
      fill: "#FCA326"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85516 13.345H10.1126L6.55879 2.42487C6.51796 2.30295 6.43984 2.19695 6.33549 2.12185C6.23113 2.04675 6.10581 2.00635 5.97724 2.00635C5.84867 2.00635 5.72335 2.04675 5.61899 2.12185C5.51463 2.19695 5.43652 2.30295 5.39568 2.42487L1.85516 13.345Z",
    fill: "#E24329",
    style: {
      fill: "#E24329"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 31.4712L21.8925 13.3392H30.1527L16.0002 31.4712Z",
    fill: "#FC6D26",
    style: {
      fill: "#FC6D26"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1471 13.345L31.9396 18.8543C32.0197 19.0992 32.0201 19.3631 31.9407 19.6082C31.8614 19.8533 31.7063 20.067 31.4979 20.2184L16.0002 31.4712L30.1433 13.345H30.1471Z",
    fill: "#FCA326",
    style: {
      fill: "#FCA326"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1509 13.345H21.8945L25.4416 2.42488C25.4822 2.30285 25.5601 2.19669 25.6644 2.12146C25.7687 2.04622 25.8941 2.00574 26.0227 2.00574C26.1513 2.00574 26.2766 2.04622 26.3809 2.12146C26.4852 2.19669 26.5632 2.30285 26.6037 2.42488L30.1509 13.345Z",
    fill: "#E24329",
    style: {
      fill: "#E24329"
    }
  }))));
};
export default SvgGitlab;